var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-simulators-chat container",class:{ fullscreen: !!this.$route.params.slug }},[_c('div',{staticClass:"position-relative"},[_c('iframe',{staticClass:"w-100 py-0 my-0",attrs:{"src":`https://api.m60.com.br/v1/chatproxy?code=${_vm.code}`,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }